// organize-imports-ignore
import './public-path'; // Must run first: sets __webpack_public_path__ before any eager module or dynamic import resolves an asset/chunk URL
import { datadogLogs } from '@datadog/browser-logs';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '~/app/App';
import { setupErrorHandlers } from '~/modules/common/utils/unhandledErrorHandlers';
import './i18n';

const { IS_ON_PREM, STRIPE_PUBLISHABLE_KEY } = window.appConfig;
const isOnPrem = IS_ON_PREM === 'true';

/** Send error logs to DataDog. */
if (window.appConfig.DATADOG_CLIENT_TOKEN) {
  datadogLogs.init({
    clientToken: window.appConfig.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    env: window.appConfig.DEPLOY_ENV || 'local',
    service: 'axe_devtools_app',
    forwardErrorsToLogs: true
  });
}

// Setup handlers for unhandled synchronous errors and promise rejections
setupErrorHandlers(datadogLogs.getLogger('global'));

if (
  !isOnPrem &&
  !STRIPE_PUBLISHABLE_KEY &&
  process.env.NODE_ENV === 'development'
) {
  // eslint-disable-next-line no-console
  console.error(
    '**Stripe publishable key environment variable not set**\n**Add an environment variable STRIPE_PUBLISHABLE_KEY**'
  );
}

const container = document.getElementById('app');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- #app is always present in index.html
const root = createRoot(container!);
root.render(
  <App isOnPrem={isOnPrem} stripePublishableKey={STRIPE_PUBLISHABLE_KEY} />
);
